import React from 'react';
import validator from 'validator';
import TeamForm from './TeamForm';
import EditPage from '../EditPage';
import GreenLeafApi from '../utils/GreenLeafApi';
import ContactType from '../utils/ContactType';
import CreateContactModal from './CreateContactModal';

class EditTeamPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isCreating: !props.match.params.teamId,
      errors: {},
      error: null,
      teamContacts: [],
      team: {
        name: '',
        size: '',
        purpose: '',
        program_id: props.match.params.programId
      },
      productOwner: null,
      scrumMaster: null,
      typeCreating: ContactType.PRODUCT_OWNER
    };

    this.saveTeam = this.saveTeam.bind(this);
    this.updateTeamState = this.updateTeamState.bind(this);
    this.getContacts = this.getContacts.bind(this);
    this.saveContact = this.saveContact.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  async componentDidMount() {
    if (!this.state.isCreating) {
      try {
        const team = (await GreenLeafApi.Team.get({teamId: this.props.match.params.teamId})).data[0];
        team.size += '';

        const teamContacts = (await GreenLeafApi.TeamContact.get({teamId: team.id})).data;
        this.setState({teamContacts: teamContacts, team: team});

        teamContacts.forEach(async tc => {
          const contact = (await GreenLeafApi.Contact.get({contactId: tc.contact_id})).data;
          contact[0].name = contact[0].first_name + ' ' + contact[0].last_name;
          switch (tc.type_id) {
            case ContactType.SCRUM_MASTER:
              this.setState({scrumMaster: contact[0]});
              break;
            case ContactType.PRODUCT_OWNER:
              this.setState({productOwner: contact[0]});
              break;
            default:
              console.error('Invalid contact type!');
          }
        });
      } catch (e) {
        this.setState({error: e.errors});
      }
    }
  }

  async saveTeam(event) {
    event.preventDefault();
    if(this.validate(this.state)) {
      try {
        const team = (await (this.state.isCreating ? GreenLeafApi.Team.create(this.state.team)
          : GreenLeafApi.Team.update(this.state.team)));

        let promises = [];
        if (team.isOkay) {
          this.state.teamContacts.forEach(tc => {
            promises.push(GreenLeafApi.TeamContact.delete(tc));
          });

          if (this.state.productOwner) {
            promises.push(GreenLeafApi.TeamContact.create(
              { teamId: team.data.id, contactId: this.state.productOwner.id, typeId: ContactType.PRODUCT_OWNER }
            ));
          }
          if (this.state.scrumMaster) {
            promises.push(GreenLeafApi.TeamContact.create(
              { teamId: team.data.id, contactId: this.state.scrumMaster.id, typeId: ContactType.SCRUM_MASTER }
            ));
          }

          await Promise.all(promises);
          this.props.history.goBack();
        }
      } catch (e) {
        this.setState({error: e.errors});
      }
    }
  }

  getContacts(input) {
    if (!input || input.length < 3) {
      return Promise.resolve({ options: [] });
    }

    input = input.split(' ');

    try {
      return GreenLeafApi.Contact.get(
        {
          companyId: this.props.match.params.companyId,
          firstName: `%25${input[0]}%25`,
          lastName: `%25${input[1] ? input[1] : ''}%25`
        })
        .then(options => {
          this.setState({ contacts: options.data });

          options.data.forEach(o => o.name = o.first_name + ' ' + o.last_name);

          return { options: options.data };
        });
    } catch (e) {
      this.setState({error: e.errors});
    }
  }

  cancel = () => {
    this.props.history.goBack();
  };

  updateTeamState(event) {
    let errors = this.state.errors;
    const field = event.target.name;
    errors[field] = null;
    let state = { errors, team: this.state.team };
    state.team[field] = event.target.value;
    return this.setState(state);
  }

  validate() {
    const requiredFields = ['name', 'size'];
    let errors = {};

    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state.team[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    this.setState({errors: errors});
    return Object.keys(errors).length === 0;
  }

  selectContact(option, type) {
    if(!option) {
      this.setState((state) => {
        switch (type) {
          case ContactType.PRODUCT_OWNER:
            state.productOwner = null;
            break;
          case ContactType.SCRUM_MASTER:
            state.scrumMaster = null;
            break;
          default:
            console.error('Invalid contact type.');
        }

        return state;
      });
    } else if (option.id) {
      this.setState((state) => {
        switch (type) {
          case ContactType.PRODUCT_OWNER:
            state.productOwner = option;
            break;
          case ContactType.SCRUM_MASTER:
            state.scrumMaster = option;
            break;
          default:
            console.error('Invalid contact type.');
        }

        return state;
      });
    } else {
      this.setState({ showModal: true, typeCreating: type });
    }
  }

  async saveContact(contact) {
    contact.company_id = this.props.match.params.companyId;
    try {
      let con = (await GreenLeafApi.Contact.create(contact)).data;
      con.name = con.first_name + ' ' + con.last_name;
      this.setState({ showModal: false });
      this.state.typeCreating === ContactType.PRODUCT_OWNER ? this.setState({ productOwner: con })
        : this.setState({ scrumMaster: con });
    } catch (e) {
      this.setState({error: e.errors});
    }
  }

  render() {
    return (
      <div>
        <EditPage
          editType={'Team'}
          isCreating={this.state.isCreating}
          error={this.state.error}>
          <TeamForm
            onSave={this.saveTeam}
            onChange={this.updateTeamState}
            onCancel={this.cancel}
            getContacts={this.getContacts}
            selectProductOwner={(option) => { this.selectContact(option, ContactType.PRODUCT_OWNER); }}
            selectScrumMaster={(option) => { this.selectContact(option, ContactType.SCRUM_MASTER); }}
            errors={this.state.errors}
            preset={this.state.team}
            productOwner={this.state.productOwner}
            scrumMaster={this.state.scrumMaster}/>
        </EditPage>

        { this.state.showModal &&
          <CreateContactModal
            show={this.state.showModal}
            handleClose={() => this.setState({ showModal: false })}
            onSave={this.saveContact}/>
        }
      </div>
    );
  }
}

export default EditTeamPage;


// WEBPACK FOOTER //
// ./src/components/teams/EditTeamPage.js